import { HttpClient } from '@shared/adapters/HttpClient';
import { OrderActivities } from '../models/Activities';

export class ActivitiesApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getOrderActivities(orderId: number): Promise<OrderActivities> {
    const response = await this.httpClient.get<any>(
      `/orders/${orderId}/activities`
    );
    return response.data;
  }
}
